<template>
  <!-- 右下角悬浮「小程序」入口：hover 弹出小程序码（参考文抓抓站内设计） -->
  <div class="mp-float" @mouseenter="open = true" @mouseleave="open = false">
    <Transition name="pop">
      <div v-if="open" class="mp-pop card">
        <p class="mp-pop__title">AI配音小狐狸 · 微信小程序</p>
        <MiniProgramQr bare />
        <p class="mp-pop__tip">手机扫码 · 随时随地配音</p>
      </div>
    </Transition>
    <button class="mp-btn" type="button" aria-label="小程序码入口" @click="open = !open">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" width="24" height="24" aria-hidden="true">
        <rect x="3" y="3" width="7" height="7" rx="1.2" />
        <rect x="14" y="3" width="7" height="7" rx="1.2" />
        <rect x="3" y="14" width="7" height="7" rx="1.2" />
        <path d="M14 14h3v3h-3z" />
        <path d="M20.5 14h.5v.5h-.5zM14 20.5h.5v.5H14zM18 18.5h.5v.5H18zM20.5 17.5h.5v.5h-.5z" />
      </svg>
      <span class="mp-btn__text">小程序</span>
    </button>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import MiniProgramQr from './MiniProgramQr.vue'

const open = ref(false)
</script>

<style scoped>
.mp-float {
  position: fixed;
  right: 24px;
  bottom: 32px;
  z-index: 90;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.mp-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3px;
  width: 60px;
  height: 60px;
  border: none;
  border-radius: 50%;
  background: var(--color-text);
  color: var(--color-bg);
  cursor: pointer;
  box-shadow: var(--shadow-lg);
  transition: transform 0.15s ease, background 0.15s ease;
}

.mp-btn:hover {
  background: var(--color-primary);
  transform: scale(1.05);
}

.mp-btn__text {
  font-size: 10px;
  letter-spacing: 0.08em;
}

.mp-pop {
  position: absolute;
  bottom: 72px;
  right: 0;
  width: 172px;
  padding: 16px;
  box-shadow: var(--shadow-lg);
  text-align: center;
}

.mp-pop__title {
  margin: 0 0 12px;
  font-size: 13px;
  font-weight: 700;
  color: var(--color-text);
}

.mp-pop__tip {
  margin: 10px 0 0;
  font-size: 12px;
  color: var(--color-text-4);
}

.pop-enter-active,
.pop-leave-active {
  transition: opacity 0.18s ease, transform 0.18s ease;
}

.pop-enter-from,
.pop-leave-to {
  opacity: 0;
  transform: translateY(8px);
}
</style>
